import withConfigTransport from '../../services/config-transport/withConfigTransport'
import VaChip from './VaChip.vue'

export default withConfigTransport(VaChip)
